import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import Navbar from "./Navbar";
import Footer from "./Footer";
import PageTransition from "./PageTransition";
import LoadingOverlay from "./LoadingOverlay";

export const Layout = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(true);

  // Splash shows only once on initial app mount (≈2.2s). No re-trigger on route changes.
  useEffect(() => {
    const t = setTimeout(() => setLoading(false), 2200);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="App bg-white text-[#0F172A]">
      <Navbar />
      <main>
        <AnimatePresence mode="wait" initial={false}>
          <PageTransition key={location.pathname}>
            <Outlet />
          </PageTransition>
        </AnimatePresence>
      </main>
      <Footer />
      <AnimatePresence>{loading && <LoadingOverlay key="loader" />}</AnimatePresence>
    </div>
  );
};

export default Layout;
